import type { ProfileEventHistory } from '@/lib/contacts/types'
import { displayDateTime } from '@/lib/dates'
import { OwnedChip } from '@/components/OwnedChip'

export function PersonEventHistory({
  history,
  timeZone = 'UTC',
}: {
  history: ProfileEventHistory[]
  timeZone?: string
}) {
  if (history.length === 0) return null

  return (
    <section className="px-4 py-3">
      <h3 className="text-body font-semibold text-foreground">Event history</h3>
      <ul className="flex flex-col gap-3 text-body-sm text-muted-foreground">
        {history.map((order) => (
          <li key={order.id} className="flex flex-wrap items-baseline gap-x-2 gap-y-1">
            <span className="flex items-center gap-2 text-foreground">
              {order.event}
              <OwnedChip owner={order.owner} />
            </span>
            <span>
              Order #{order.id}
              {order.invoice_number ? ` · Invoice #${order.invoice_number}` : ''}
            </span>
            <span className="break-words text-pewter sm:whitespace-nowrap">
              {order.status} · {displayDateTime(order.ordered_at, timeZone)}
            </span>
          </li>
        ))}
      </ul>
    </section>
  )
}
